<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li class="active">COMANDOS PERSONALIZADOS PARA TODOS OS CLIENTES</li>
                </ol>

                <div class="row">
                    <div class="col-md-3">
                        <comandos-todos/>
                    </div>

                    <div class="col-md-9">

                        <form class="form-horizontal" >

                            <div class="panel panel-info">
                                <div class="panel-heading">COMANDOS PERSONALIZADOS</div>
                                <div class="panel-body" >

                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <label for="inputIp" class="control-label">COMANDO A SER ENVIADO:</label>
                                            <textarea rows="5" v-model="comando.comando" class="form-control" id="inputIp"></textarea>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="col-sm-10">
                                            <button type="button" @click="send()" class="btn btn-success">ENVIAR COMANDO</button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <button type="button" @click="comando.contratos = []" class="btn btn-danger btn-xs">
                                DESMARCAR TODOS</button>
                            <button type="button" @click="markAll()" class="btn btn-info btn-xs">
                                MARCAR TODOS</button>
                            <br/><br/>

                            <div class="form-group" v-for="c in contratos" v-bind:key="c._id">
                                <div class="col-lg-10">
                                    <div class="checkbox">
                                        <label style="font-size: 17px">
                                            <input style="padding: 14px; " type="checkbox" :value="c._id" v-model="comando.contratos">
                                            {{ c.cliente.nome | uppercase }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </form>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import comandosTodos from "../../menus/comandos_todos.vue";
import { Contratos } from "../../class/index";

export default {
    components: {
        comandosTodos
    },
    data() {
        return {
            comando: {
                comando: null,
                contratos: []
            },
            contratos: []
        };
    },
    beforeMount() {
        Contratos.all()
            .then(rows => {
                this.contratos = rows;
                this.markAll();
            })
            .catch(err => console.error(err));
    },
    methods: {
        markAll() {
            this.contratos.forEach(r => {
                this.comando.contratos.push(r._id);
            });
        },
        send() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Enviar Comando",
                    text: "Posso enviar o comando para Todos?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Contratos.sendComandoAll(this.comando)
                                .then(() => {
                                    this.comando.comando = null;
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
